import NoticeIcon from 'assets/icons/notice-yellow-icon.svg';
import AlertPopup from 'components/common/PortalModal/popups/AlertPopup';
import { useDetectDevice } from 'hooks/useDetectDevice';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';

const AlertModal = ({
  isShow,
  title,
  content,
  action,
  actionClose,
  modalStyles,
  modalData,
  modalOptions,
}) => {
  const { closePortalModalName } = usePortalModal();
  const { isDesktop } = useDetectDevice();

  const { buttonLabel1, buttonLabel2 } = modalOptions || {};

  const { alignContent } = modalStyles || {};

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <AlertPopup
      isOpen={isShow}
      imageSrc={NoticeIcon}
      imagesStyles={{
        width: isDesktop ? '124px' : '75px',
        height: isDesktop ? '100px' : '60px',
      }}
      text={title || ''}
      content={content || ''}
      buttonLabel1={buttonLabel1}
      onClose={handleOnClose}
      buttonLabel2={buttonLabel2}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
      modalStyles={modalStyles}
      modalData={modalData}
    />
  );
};

export default AlertModal;
